<template>
  <div>
    <van-nav-bar
      title="完善账户资料"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      label="姓名"
      v-if="inScope('username')"
      v-model="userInfo.username"
    />
    <van-field
      label="身份证号码"
      v-if="inScope('certNo')"
      v-model="userInfo.certNo"
    />
    <van-field
      label="银行卡号"
      v-if="inScope('bankAccount')"
      v-model="userInfo.bankAccount"
    />
    <van-field
      label="开户行"
      v-if="inScope('bankName')"
      v-model="userInfo.bankName"

    />
    <template  v-if="inScope('mobile')">
    <van-field
      label="联系电话"
      v-model="userInfo.mobile"

    />
    <van-field
      v-model="userInfo.code"
      label-class="label-class"
      type="number"
      label="验 证 码"
    >
      <template #button>
        <van-button slot="button" size="small" @click="sendVerifySms" v-if="codeSended == false"
                    type="info">获取验证码
        </van-button>
        <van-button slot="button" size="small" disabled v-else type="info">{{codeSendBtntext}}
        </van-button>
      </template>
    </van-field>
    </template>
    <template v-if="inScope('address')">
      <van-field
        v-model="userInfo.city"
        label-class="label-class"
        type="text"
        @click="showArea=true"
        readonly
        label="选择地区"
      />
      <van-field
        label="详细地址"
        v-model="userInfo.address"
        type="textarea"
      />
    </template>
    <div style="margin: 16px;">
      <van-button round block type="info" @click="onSubmit">
        提交
      </van-button>
    </div>

    <van-popup position="bottom" v-model="showArea">
      <van-area title="请选择" @cancel="showArea=false" @confirm="checkAddress" :area-list="areaList" />
    </van-popup>
  </div>
</template>

<script>
  import { areaList } from '@vant/area-data';
  export default {
    data() {
      return {
        showArea:false,
        areaList,
        show: false,
        userInfo: {},
        codeSended: false,
        codeSendBtntext: '',
        posting:false,
        scope:[]
      };
    },
    methods: {
      checkAddress(arr){
        if(arr && arr.length==3){
          this.userInfo.city = '';
          let select = [];
          for(let i in arr){
            select.push(arr[i].name)
          }
          this.userInfo.city = select.join(" ")
        }
        this.showArea = false
      },
      inScope(key){
        for (let i in this.scope){
          if(key == this.scope[i]){
            return true
          }
        }
        return false;
      },
      onClickLeft() {
        window.history.go(-1)
      },
      onSubmit() {
        for(let i in this.scope){
          if(!this.userInfo[this.scope[i]]){
            return this.$toast("请完善资料")
          }
        }
        if(this.posting) return false;
        this.posting = true
        this.fetchDataPost("/agent/saveBankInfo",this.userInfo,res=>{
          this.posting = false
          if(res.code){
            this.$router.back()
            this.$toast.success(res.msg)
          }else{
            this.$toast.fail(res.msg)
          }
        })
      },
      sendVerifySms() {
        if (!this.userInfo.mobile) {
          this.$toast.fail("账号未绑定手机号码")
          return false
        }
        if (this.codeSended == true) return false
        this.$toast.loading("发送中")
        this.fetchData("/sms/sendVerifyOperatorCode", {mobile: this.userInfo.mobile}, (res) => {
          this.$toast.loading().clear()
          if (res.code) {
            this.codeSended = true
            let i = 60
            let intval = setInterval(() => {
              if (i <= 0) {
                clearInterval(intval)
                this.codeSended = false
                this.codeSendBtntext = "获取验证码"
              } else {
                this.codeSendBtntext = "( " + i + "s )"
                i--
              }
            }, 1000)
            this.$toast.success(res.msg)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
    },
    created: function () {
      this.fetchData('/account/info', {}, (res) => {
        if(res.data.bank_info && res.data.bank_info.id){
          this.userInfo = res.data.bank_info
          console.log(this.userInfo)
        }
      })
      this.scope = this.$route.query.scope
    }
  };
</script>
<style lang="scss" scoped>
  .label-class {
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bankInfo.vue